import React from 'react'
import { ControlledModal, ModalTitle } from '../../layouts/components/modal'
import { Logo } from '../../components/simple/logo'
import { useTranslation } from '../../providers/translation'
import { Select } from '../../components/form/select'
import { TextInput } from '../../components/form/textInput'
import { Button } from '../../components/simple/button'
import { makeRequest, showAxiosErrorAsToast } from '../../request'
import { Toasts } from '../../providers/toast'
import { useAppContext } from '../../providers/context'
import { useShowWithPriorityIfNotShownRecently } from '../../providers/modalPriorityProvider'

export const TEACHER_TYPES = [
  { name: 'Please pick a role', value: '', initialOnly: true },
  { name: 'Classroom Teacher', value: 'Classroom Teacher' },
  { name: 'Administrative Assistant', value: 'Administrative Assistant' },
  { name: 'Assistant Principal', value: 'Assistant Principal' },
  { name: 'Community Liaison', value: 'Community Liaison' },
  { name: 'Counselor', value: 'Counselor' },
  { name: 'District Staff', value: 'District Staff' },
  { name: 'ESOL/ELL Teacher', value: 'ESOL/ELL Teacher' },
  { name: 'Interventionist', value: 'Interventionist' },
  { name: 'Librarian', value: 'Librarian' },
  { name: 'Nurse', value: 'Nurse' },
  { name: 'Principal', value: 'Principal' },
  { name: 'Social Worker', value: 'Social Worker' },
  { name: 'Special Education Teacher', value: 'Special Education Teacher' },
  { name: 'Specialist', value: 'Specialist' },
  { name: 'Superintendent', value: 'Superintendent' },
  { name: 'Other', value: 'Other' },
]

export const TeacherTypeModal: React.FC = () => {
  const { tr } = useTranslation()
  const { reloadUser } = useAppContext()
  const [loading, setLoading] = React.useState(false)
  const [type, setType] = React.useState(TEACHER_TYPES[0])
  const [otherMessage, setOtherMessage] = React.useState('')

  const { active, onComplete } = useShowWithPriorityIfNotShownRecently(600, 'teacherTypeModal')

  return (
    <ControlledModal
      size="xs"
      onOpenChange={(o) => {
        if (!o) onComplete()
      }}
      open={active}
      disabled={loading}
    >
      <div className="flex items-center gap-2">
        <Logo />
        <ModalTitle className="mr-4 text-xl font-bold">{tr('Help us cater to you!')}</ModalTitle>
      </div>
      <div className="mt-2 font-bold">Select your role</div>
      <Select options={TEACHER_TYPES} value={type} onChange={setType} />
      {type.value === 'Other' && (
        <>
          <b>If other, please specify</b>
          <TextInput value={otherMessage} onChange={setOtherMessage} placeholder="role" />
        </>
      )}
      <Button
        logo
        className="mt-5 self-center"
        onClick={() => {
          setLoading(true)
          makeRequest('/frontend_api/editUser', { teacherType: type.value, teacherTypeOtherMessage: otherMessage })
            .then(() => {
              Toasts.showToast({ message: 'Thank you for your response!' })
              reloadUser()
              onComplete()
            })
            .catch(showAxiosErrorAsToast)
            .finally(() => setLoading(false))
        }}
        disabled={(type.value === 'Other' && otherMessage.trim() === '') || type.value === ''}
      >
        Continue
      </Button>
    </ControlledModal>
  )
}
